/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, YoutubeIntegrationGetStationStatsCountryViewersPathParams, YoutubeIntegrationGetStationStatsCountryViewersQueryParams, YoutubeIntegrationGetStationStatsCountryViewers401, YoutubeIntegrationGetStationStatsCountryViewers403 } from "../models/YoutubeIntegrationGetStationStatsCountryViewers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { youtubeIntegrationGetStationStatsCountryViewers } from "../axios/youtubeIntegrationGetStationStatsCountryViewers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const youtubeIntegrationGetStationStatsCountryViewersQueryKey = (station: YoutubeIntegrationGetStationStatsCountryViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsCountryViewersQueryParams) => ["api-v2", { url: '/youtube-integration/v1/stats/viewers/:station/country', params: {station:station} }, ...(params ? [params] : [])] as const

export type YoutubeIntegrationGetStationStatsCountryViewersQueryKey = ReturnType<typeof youtubeIntegrationGetStationStatsCountryViewersQueryKey>

export function youtubeIntegrationGetStationStatsCountryViewersQueryOptions(station: YoutubeIntegrationGetStationStatsCountryViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsCountryViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = youtubeIntegrationGetStationStatsCountryViewersQueryKey(station, params)
        return queryOptions<YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetStationStatsCountryViewers401 | YoutubeIntegrationGetStationStatsCountryViewers403>, YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return youtubeIntegrationGetStationStatsCountryViewers(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns stats for every channel in the live-viewers catalog whose `countryCode` matches this station’s channel (same scope as `ChannelRepository.findByCountry`). `metadata.channels[*].isSelf` marks this station’s `youtubeChannelId`.
 * @summary Viewer time series for same-country catalog channels
 * {@link /youtube-integration/v1/stats/viewers/:station/country}
 */
export function useYoutubeIntegrationGetStationStatsCountryViewers<TData = YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, TQueryData = YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, TQueryKey extends QueryKey = YoutubeIntegrationGetStationStatsCountryViewersQueryKey>(station: YoutubeIntegrationGetStationStatsCountryViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsCountryViewersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetStationStatsCountryViewers401 | YoutubeIntegrationGetStationStatsCountryViewers403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? youtubeIntegrationGetStationStatsCountryViewersQueryKey(station, params)
         

         const query = useQuery({
          ...youtubeIntegrationGetStationStatsCountryViewersQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<YoutubeIntegrationGetStationStatsCountryViewers401 | YoutubeIntegrationGetStationStatsCountryViewers403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}